// extracted by mini-css-extract-plugin
export default {"verified":"Badge_verified__yHZNv","count":"Badge_count__8cAeq","role":"Badge_role__iENyu","admin":"Badge_admin__CMwp8","moderator":"Badge_moderator__7tFoc"};